// Web treatment for the phone's hamburger menu.
//
// The Dashboard and Profile screens open a slide-in menu from a hamburger
// button pinned to the top-left of the header (My Profile, All Tasks, My
// Documents, Dashboard, Feedback, Logout). On the desktop frame the
// sidebar already offers those destinations, so the button is one more
// thing to explain; hide it there. The phone and tablet frames keep it,
// as a device would. Applied inside the `react-native` shim's
// `StyleSheet.create`, like sheetStyle.ts and lockUnlockStyle.ts, so the
// screens do not change and mobile never sees it. The button is
// absolutely positioned, so hiding it moves nothing else.
//
// Matched by style-key signature: a sheet with `hamburgerButton` and
// `hamburgerBar`. Anything else passes through untouched.

import { layoutModeFor } from './useLayoutMode';

function widthNow(): number {
  return typeof window === 'undefined' ? 0 : window.innerWidth;
}

export function hideHamburgerOnDesktop<T extends Record<string, unknown>>(
  styles: T,
  viewportWidth: number = widthNow(),
): T {
  const button = styles.hamburgerButton;
  if (!button || typeof button !== 'object' || !('hamburgerBar' in styles)) return styles;
  if (layoutModeFor(viewportWidth) !== 'desktop') return styles;
  return { ...styles, hamburgerButton: { ...(button as Record<string, unknown>), display: 'none' } };
}
